import Button from "@/common/components/Button";
import Skeleton from "@/common/components/Skeleton";
import { ChevronsRightIcon, InfoIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { alertSections, infoBlocks } from "./constants";
import GoBackButton from "@/common/components/GoBackButton";


const PendingScreenPosShow = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/pos" />
          <p className="text-white-400 font-normal">POS</p>
          <ChevronsRightIcon color="#ffffffb3" />
          <Skeleton width={100} />
        </div>
      </div>
      <div className="bg-[#FFFFFF0D] w-full rounded-lg p-6 flex flex-col gap-4">
        {alertSections.map((section, index) => (
          <div key={index} className="bg-[#FFFFFF0D] w-full p-2 flex flex-row justify-between overflow-hidden">
            <div className="flex flex-row gap-2">
                <InfoIcon className="w-[28px]" strokeWidth={1} color="var(--warning)"/>
                <div>
                    <h2 className="font-bold text-white text-[13px] m-0">{section.title}</h2>
                    <h2 className="text-white text-[11px] italic m-0 overflow-hidden text-ellipsis whitespace-nowrap">
                    {section.description}
                    </h2>
                </div>
            </div>
            <Button
                className={twMerge('py-2 px-4 rounded-sm cursor-pointer hover:bg-[section.buttonColor] shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)] whitespace-nowrap',
                     section.buttonColor)}
                disabled
            >
                {section.buttonText}
            </Button>
          </div>

        ))}
         <div className="bg-[#FFFFFF0D] w-full p-2 flex flex-row justify-between overflow-hidden">
          <div className="flex flex-row gap-2 content-center items-center">
              <InfoIcon className="w-[28px]" strokeWidth={1} color="var(--warning)"/>
              <div>
                  <h2 className="font-bold text-white text-[13px] ">Libere esse POS</h2>
              </div>
          </div>
          <Button
            className={'py-2 px-4 bg-primary-blue rounded-sm cursor-pointer hover:bg-[section.buttonColor] whitespace-nowrap'}
            disabled
          >
            Liberar POS
          </Button>
        </div>

        {infoBlocks.map((block, index) => (
          <div key={index} className="bg-[#FFFFFF1A] w-full h-[93px] rounded-lg p-3 flex flex-col justify-center overflow-hidden">
            <h2 className="font-bold text-white text-[16px] m-0">{block.label}</h2>
            <h2 className="text-white text-[14px] m-0 overflow-hidden text-ellipsis whitespace-nowrap">
              <Skeleton width={200}/>
            </h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingScreenPosShow;
